import * as React from 'react';
import {
  Grid, Card, CardHeader, CardContent, CardActions, Box, Typography, Paper, TextField, Button, CircularProgress,
} from '@material-ui/core';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import type IRepairRejectReason from './RepairRejectReasonInterfaces';
import GetStations from '../../lib/SWRfetchers/getStations';
import type ILabelEnumPair from '../global/GlobalInterfaces';
import ChipSelect from '../ChipSelect';

interface RepairRejectReasonAddProps {
  formValues: IRepairRejectReason,
  setFormValues: (values: IRepairRejectReason) => void,
  secondaryButtonAction: () => void,
  primaryButtonAction: () => void,
  interfaceType: 'Add' | 'Edit',
  loading: boolean,
}

const RepairRejectReasonAdd: React.FC<RepairRejectReasonAddProps> = ({
  formValues, setFormValues, secondaryButtonAction, primaryButtonAction, interfaceType, loading,
}) => {
  const { stations } = GetStations();

  const handleIsBroncaChange = (isBronca: boolean) => {
    const tempFormValues: IRepairRejectReason = { ...formValues, isBroncaReason: isBronca };
    setFormValues(tempFormValues);
  };

  return (
    <Paper>
      <Card>
        <CardHeader
          title={(
            <Typography variant="h6" display="inline">{ interfaceType === 'Add' ? 'Add Repair Reject Reason' : 'Edit Repair Reject Reason'}</Typography>
              )}
          disableTypography
        />
        <CardContent>
          <Grid container spacing={4}>
            <Grid item md={6} xs={12}>
              <Box pl={2}>
                <TextField
                  id="reject-reason-value-input"
                  value={formValues?.reason ?? null}
                  type="text"
                  label="Repair Reject Reason"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    const data = e.target.value;
                    if (data) {
                      const tempFormValues: IRepairRejectReason = { ...formValues, reason: data };
                      setFormValues(tempFormValues);
                    } else {
                      const tempFormValues: IRepairRejectReason = { ...formValues, reason: null };
                      setFormValues(tempFormValues);
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              {
                stations ? (
                  <Autocomplete
                    value={formValues?.station || null}
                    onChange={(e, data: ILabelEnumPair | null) => {
                      if (data) {
                        const tempFormValues: IRepairRejectReason = { ...formValues, station: data };
                        setFormValues(tempFormValues);
                      } else {
                        const tempFormValues: IRepairRejectReason = { ...formValues, station: null };
                        setFormValues(tempFormValues);
                      }
                    }}
                    autoHighlight
                    autoSelect
                    options={stations.sort((a, b) => a.label.localeCompare(b.label))}
                    getOptionLabel={(option) => option.label.toString()}
                // prop spreading is directly from MUI tsx example
                // eslint-disable-next-line react/jsx-props-no-spreading
                    renderInput={(params) => <TextField required {...params} id="station-type-input" label="Station" variant="outlined" />}
                  />
                ) : (<Skeleton height="56px" variant="rect" />)
              }
            </Grid>
            <Grid item md={6} xs={6} style={{ marginLeft: '20px' }}>
              <Typography><b>{'Is Bronca'}</b></Typography>
              <Box pt={2} alignItems="center" display="flex">
                <Box pr={1}>
                  <ChipSelect label="No" selected={!formValues.isBroncaReason} handleClick={() => handleIsBroncaChange(false)} />
                </Box>
                <ChipSelect label="Yes" selected={formValues.isBroncaReason} handleClick={() => handleIsBroncaChange(true)} />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container direction="row-reverse" spacing={2}>
            <Grid item>
              <Button disabled={loading} color="primary" variant="contained" onClick={primaryButtonAction}>
                {loading ? <CircularProgress size={25} /> : <>{ interfaceType === 'Add' ? 'ADD REPAIR REJECT REASON' : 'EDIT REPAIR REJECT REASON'}</> }
              </Button>
            </Grid>
            {
                  interfaceType === 'Add' ? (
                    <Grid item>
                      <Button variant="text" color="primary" onClick={secondaryButtonAction}>{'RESET'}</Button>
                    </Grid>
                  ) : (
                    <Grid item>
                      <Button variant="text" color="secondary" onClick={secondaryButtonAction}>{'CANCEL'}</Button>
                    </Grid>
                  )
                }
          </Grid>
        </CardActions>
      </Card>
    </Paper>
  );
};
export default RepairRejectReasonAdd;
